<div [formGroup]="frmSubcategoria" class="item-subcategoria">
    <div formArrayName="subcategorias" *ngFor="let subcategory of subcategorias.controls; let j=index" class="row mt15">
        <div class="col" [formGroupName]="j" >
            <ng-select *ngIf="list.length > 0 && subcategory.controls.showText.value == false" class="ng-select-visible" formControlName="subcategoria" [items]="list" placeholder="Selecione uma subcategoria" (change)="onChangeSubcategoria(subcategory)" (clear)="onChangeDetail()" bindLabel="ds_subcategoria" bindValue="idsubcategoria"></ng-select>
            <input *ngIf="list.length == 0 || subcategory.controls.showText.value == true" type="text" class="form-control" placeholder="Preencha com a nova subcategoria" (keyup)="onChangeDetail()" formControlName="subcategoria" />
            <button *ngIf="list.length > 0 && subcategory.controls.showText.value == false && subcategory.controls.subcategoria.value == null" (click)="newSubcategory(subcategory)" type="button" class="btn btn-warning-outline">nova</button>
            <button *ngIf="list.length > 0 && subcategory.controls.showText.value == true" (click)="newSubcategory(subcategory)" type="button" class="btn btn-warning-outline">selecionar</button>
            <button (click)="removeSubcategoria(subcategorias, j)" type="button" class="btn btn-danger-outline">remover</button>
        </div>
        <div *ngIf="subcategory.controls.subcategorias && subcategory.controls.subcategorias.controls.length > 0" class="pnl-subcategoria">
            <div class="row">
                <app-subcategoria-item [id]="j" [list]="subcategory.controls.list.value" [subcategorias]="subcategory.controls.subcategorias" (onChangeEvent)="eventChange()"></app-subcategoria-item>
            </div>
        </div>
        <div *ngIf="subcategory.controls.subcategoria.value != null" class="pnl-subcategoria">
          <div class="row">
            <div class="item-subcategoria">
              <div class="row mt15">
                <div class="col">
                  <button (click)="addNewSubcategory(subcategory)" type="button" class="btn btn-primary-outline btn-new-subcategoria">Adicionar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="subcategoria-loading" *ngIf="subcategory.controls.loadingSubcategoria && subcategory.controls.loadingSubcategoria.value == true">
          <div class="loading">
            <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
              <div class="ldio-ns36390yc">
                <div></div>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
